"use strict";

exports.__esModule = true;
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireWildcard(require("react"));

var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _SelectableTable = _interopRequireDefault(require("./SelectableTable"));

var _SelectableSortableTable = _interopRequireDefault(require("./SelectableSortableTable"));

var _SortableTable = _interopRequireDefault(require("./SortableTable"));

var _TableBase = _interopRequireDefault(require("./TableBase"));

var _utils = require("./utils");

var _constants = require("./constants");

var _propTypes = require("./propTypes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Table =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Table, _Component);

  function Table() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "columns", void 0);

    _defineProperty(_assertThisInitialized(_this), "comparators", void 0);

    _defineProperty(_assertThisInitialized(_this), "selectableRows", void 0);

    _defineProperty(_assertThisInitialized(_this), "sortable", void 0);

    _defineProperty(_assertThisInitialized(_this), "getColumns", (0, _memoizeOne.default)(_utils.getColumns, function (nextProps, prevProps) {
      return (0, _reactFastCompare.default)(prevProps.columns, nextProps.columns) && !prevProps.columns && (0, _reactFastCompare.default)(prevProps.data, nextProps.data);
    }));

    _defineProperty(_assertThisInitialized(_this), "getComparators", (0, _memoizeOne.default)(_utils.getComparators, function (nextProps, prevProps) {
      return (0, _reactFastCompare.default)(nextProps.columns, prevProps.columns);
    }));

    _defineProperty(_assertThisInitialized(_this), "getSelectableRows", (0, _memoizeOne.default)(_utils.getSelectableRows, _reactFastCompare.default));

    _defineProperty(_assertThisInitialized(_this), "getSortable", (0, _memoizeOne.default)(_utils.getSortable, function (nextProps, prevProps) {
      return (0, _reactFastCompare.default)(nextProps.columns, prevProps.columns);
    }));

    return _this;
  }

  var _proto = Table.prototype;

  _proto.render = function render() {
    this.columns = this.getColumns(this.props);
    this.comparators = this.getComparators(this.props);
    this.selectableRows = this.getSelectableRows(this.props.data);
    this.sortable = this.getSortable(this.props);

    var _this$props = this.props,
        defaultSelectedRows = _this$props.defaultSelectedRows,
        onToggleRow = _this$props.onToggleRow,
        onToggleAllRows = _this$props.onToggleAllRows,
        selectable = _this$props.selectable,
        selectedRows = _this$props.selectedRows,
        sortable = _this$props.sortable,
        restProps = _objectWithoutPropertiesLoose(_this$props, ["defaultSelectedRows", "onToggleRow", "onToggleAllRows", "selectable", "selectedRows", "sortable"]);

    var rootProps = _objectSpread({}, restProps, {
      columns: this.columns,
      comparators: this.comparators
    }, defaultSelectedRows ? {
      defaultSelected: this.getSelectableRows(defaultSelectedRows)
    } : undefined, onToggleRow ? {
      onToggle: onToggleRow
    } : undefined, onToggleAllRows ? {
      onToggleAll: onToggleAllRows
    } : undefined, selectedRows ? {
      selected: selectedRows
    } : undefined, selectable ? {
      selectableRows: this.selectableRows
    } : undefined, this.sortable ? {
      sortable: sortable
    } : undefined);

    if (selectable && this.sortable) {
      return (0, _core.jsx)(_SelectableSortableTable.default, rootProps);
    } else if (selectable) {
      return (0, _core.jsx)(_SelectableTable.default, rootProps);
    } else if (this.sortable) {
      return (0, _core.jsx)(_SortableTable.default, rootProps);
    } else {
      var ignoreSortable = rootProps.sortable,
          rootPropsWithoutSortable = _objectWithoutPropertiesLoose(rootProps, ["sortable"]);

      return (0, _core.jsx)(_TableBase.default, rootPropsWithoutSortable);
    }
  };

  return Table;
}(_react.Component);

_defineProperty(Table, "displayName", 'Table');

_defineProperty(Table, "defaultProps", {
  density: _constants.DENSITY.compact,
  messages: {
    deselectAllRows: 'Deselect all rows',
    deselectRow: 'Deselect row',
    selectAllRows: 'Select all rows',
    selectedRows: 'Selected rows',
    selectRow: 'Select row',
    sortColumnAscending: 'Sort column in ascending order',
    sortColumnDescending: 'Sort column in descending order'
  },
  titleAs: _constants.TITLE_ELEMENT.h4
});

Table.propTypes = process.env.NODE_ENV !== "production" ? _propTypes.tablePropTypes : {};
var _default = Table;
exports.default = _default;